import { render, staticRenderFns } from "./imgPreview.vue?vue&type=template&id=6982fd70&scoped=true&"
import script from "./imgPreview.vue?vue&type=script&lang=js&"
export * from "./imgPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6982fd70",
  null
  
)

export default component.exports